import styled from "styled-components";

const BugIdCellStyled = styled.td`
  width: 40px;
  font-weight: bold !important;
`;

export default BugIdCellStyled;
